
import {Component, Prop, Watch} from 'vue-property-decorator';
import {t} from '@/utils/helpers';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';

@Component
export default class DataTableHeader extends mixins(DebounceMixin) {
  @Prop() title!: string;
  @Prop({default: t('search_placeholder')}) placeholder!: string;
  @Prop() to!: any;
  @Prop({default: t('add')}) newText!: string;
  @Prop({default: 'white lighten-2'}) color!: string;
  @Prop({default: () => []}) columns!: [];

  search = {
    column: '',
    value: '',
  };

  @Watch('search', {deep: true})
  onSearchChanged(search: string) {
    this.$emit('input', search);
    this.debounce(() => this.$emit('search', search));
  }
}
